import { Partial } from '@40seas/entities/common';
import { CreateChargeDto } from './create.charge.dto';

export class UpdateChargeDto extends Partial(CreateChargeDto) {}
